export const S3_BUCKET_URL = "https://virtual-job-fair-file.s3.amazonaws.com";

// Unified URL for both REST API (Axios) and WebSocket (Socket.IO)
// Uses the same REACT_APP_API_BASE_URL that Axios uses
export const SERVER_URL = process.env.REACT_APP_API_BASE_URL ||
  (process.env.REACT_APP_ENV === "dev"
    ? (process.env.REACT_APP_DEV_SERVER || "http://localhost:5000")
    : (process.env.REACT_APP_PROD_SERVER || "http://localhost:5000"));

// Support Assistant ID - configurable via environment variable
export const SUPPORT_ASSISTANT_ID = process.env.REACT_APP_SUPPORT_ASSISTANT_ID || "asst_P8NuUfer28UHbljwfIE8Msye";

// Preview Server URL - use environment variable or fallback based on environment
export const PREVIEW_SERVER_URL = process.env.REACT_APP_PREVIEW_SERVER_URL ||
  (process.env.REACT_APP_ENV === "dev" ? "http://localhost:3000" : "https://preview.bellohire.com");

function isLoopbackHostname(hostname) {
  if (!hostname) return false;
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]"
  );
}

// Candidate Portal URL — share links and candidate-facing absolute URLs.
// 1) REACT_APP_CANDIDATE_PORTAL_URL when set
// 2) Real hostnames: current origin (dev.keelzo.com, www…, etc.)
// 3) localhost: prefer REACT_APP_WEB_CLIENT so port/proxy mismatches (e.g. :8000) do not leak into share links
function resolveCandidatePortalUrl() {
  const envUrl = process.env.REACT_APP_CANDIDATE_PORTAL_URL;
  if (typeof envUrl === "string" && envUrl.trim()) {
    return envUrl.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location?.hostname) {
    const { hostname, origin } = window.location;
    if (!isLoopbackHostname(hostname)) {
      return origin;
    }
    const webClient = process.env.REACT_APP_WEB_CLIENT;
    if (typeof webClient === "string" && webClient.trim()) {
      return webClient.replace(/\/$/, "");
    }
    return origin;
  }
  return process.env.REACT_APP_ENV === "dev"
    ? "http://localhost:3000"
    : "https://bellohire.com";
}

export const CANDIDATE_PORTAL_URL = resolveCandidatePortalUrl();

// Default Profile Image - configurable via environment variable
export const defaultProfileImage = process.env.REACT_APP_DEFAULT_PROFILE_IMAGE ||
  "https://img.freepik.com/free-psd/3d-illustration-person_23-2149436192.jpg";

// Google reCAPTCHA Key - configurable via environment variable
export const GOOGLE_CAPTCHA_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_KEY ||
  "6LckxkknAAAAADvomLoQrDCIXhB8ClIaoHg7SAWJ";

// Skip reCAPTCHA in dev/testing or on localhost (avoids 401 from invalid/restricted keys)
export const isTesting =
  process.env.REACT_APP_ENV === "testing" ||
  process.env.REACT_APP_ENV === "dev" ||
  (typeof window !== "undefined" && /^localhost$|^127\.0\.0\.1$/.test(window.location?.hostname || ""))
    ? true
    : false;

export const DEFAULT_AVATAR_ID = "placeholder-avatar";

export const DEFAULT_AVATAR = "placeholder-avatar-url";

// Default Avatar Background - configurable via environment variable
export const DEFAULT_AVATAR_BACKGROUND = process.env.REACT_APP_DEFAULT_AVATAR_BACKGROUND ||
  "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/4k/brown_photostudio_06_4k.hdr";

// Job Description API URL - configurable via environment variable
export const JOB_DESCRIPTION = process.env.REACT_APP_JOB_DESCRIPTION_API ||
  "https://job-description-ai-ejn4htt3oa-uc.a.run.app";

export const DefaultAvatarConfig = {
  camera: {
    cameraPosition: JSON.stringify([
      -0.7159254375517097, -2.8387461548019393, 39.5811178794745,
    ]),
    orbitalTarget: JSON.stringify([
      0.9903149785300269, -2.838746154801942, -1.3378769076385122,
    ]),
  },
  avatar: {
    url: DEFAULT_AVATAR,
    type: "female",
    position: {
      x: -2,
      y: -9,
      z: 28,
    },
    rotate: {
      x: 0,
      y: 6.3,
      z: 0,
    },
    scale: 6.0,
    speechVoice: "en-US-EmmaNeural",
    speechText: "",
    welcomeText: "Hi, Welcome",
    background: {
      id: "a443b8a0a2314a55ae5dee4dd6a151a0",
      title: "White round exhibition gallery",
      author: {
        name: "ChristyHsu",
        url: "https://sketchfab.com/ida61xq?utm_medium=embed&utm_campaign=share-popup&utm_content=",
      },
      file: "white_round_exhibition_gallery_1k.glb",
      url: "https://sketchfab.com/models/a443b8a0a2314a55ae5dee4dd6a151a0/embed?autostart=0&autospin=0&camera=0&preload=1&ui_hint=0&dnt=1",
    },
    room: {
      position: {
        x: 0,
        y: 4.4,
        z: -1.5,
      },
      scale: 5.1,
      rotate: {
        x: 0,
        y: 0,
        z: 0,
      },
    },
  },
};
// Environment tier detection
const appEnv = (process.env.REACT_APP_ENV || '').toLowerCase().trim();

export const isProduction =
  appEnv === 'prod' ||
  appEnv === 'production' ||
  (process.env.NODE_ENV === 'production' &&
    appEnv !== 'staging' &&
    appEnv !== 'test' &&
    appEnv !== 'testing' &&
    appEnv !== 'dev' &&
    appEnv !== 'development');

export const isProductionEnvironment = () => isProduction;

